import "./HotTakeVoteButton.scss";

import { PollyIcon, PollyIconName } from "../../../../../_shared/components/PollyIcon";

export type HotTakeVoteType = "up" | "down";

export const HotTakeVoteButtons: React.FC<{
  disabled?: boolean;
  selected?: HotTakeVoteType;
  onClick?: (selected: HotTakeVoteType) => void;
}> = ({ disabled, selected, onClick }) => {
  return (
    <div className="hot-take-vote-buttons">
      <HotTakeVote
        vote="up"
        selected={selected === "up"}
        disabled={disabled}
        onClick={vote => onClick && onClick(vote)}
      />
      <HotTakeVote
        vote="down"
        selected={selected === "down"}
        disabled={disabled}
        onClick={vote => onClick && onClick(vote)}
      />
    </div>
  );
};

const HotTakeVote: React.FC<{
  vote: HotTakeVoteType;
  disabled?: boolean;
  selected: boolean;
  onClick: (selected: HotTakeVoteType) => void;
}> = ({ vote, disabled, selected, onClick }) => {
  let baseClass: string = "";
  let icon: PollyIconName;

  switch (vote) {
    case "up":
      baseClass = "hot-take-vote-buttons__up-vote";
      icon = "thumbs-up-icon";
      break;

    case "down":
      baseClass = "hot-take-vote-buttons__down-vote";
      icon = "thumbs-down-icon";
      break;
  }

  const buttonClasses = [baseClass];

  if (disabled) {
    buttonClasses.push(`${baseClass}--disabled`);
  }

  if (selected) {
    buttonClasses.push(`${baseClass}--selected`);
  }

  return (
    <div className={buttonClasses.join(" ")} onClick={() => !disabled && onClick(vote)}>
      <PollyIcon icon={icon} inheritColor />
    </div>
  );
};
